enum ServiceName {
    MONEY_DELIVERY = "MONEY_DELIVERY",
    ARTICLE_DELIVERY = "ARTICLE_DELIVERY",
    PACKAGE_DELIVERY = "PACKAGE_DELIVERY",
    MISCELLANY = "MISCELLANY",
    SHOP = "SHOP",
    TOPUP = "TOPUP",
}

export default ServiceName;